import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsInputAntennaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_input_antenna"}/>
}
